import Icon from '@ant-design/icons';
import React from 'react';

const OrderDispatchedSvg = (props: React.HTMLAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M23.4 2.96L21.5467 0.72C21.1733 0.28 20.6267 0 20 0H4C3.37333 0 2.82667 0.28 2.46667 0.733333L0.613333 2.96C0.226667 3.42666 0 4.01333 0 4.66666V21.3333C0 22.8 1.18667 24 2.66667 24H21.3333C22.8 24 24 22.8 24 21.3333V4.66666C24 4.01333 23.7733 3.42666 23.4 2.96ZM12 8.66666L19.3333 16H14.6667V18.6667H9.33333V16H4.66667L12 8.66666ZM2.82667 2.66667L3.92 1.33333H19.92L21.16 2.66667H2.82667Z"
      fill="#202426"
    />
  </svg>
);

export const OrderDispatchedIcon = ({ className, ...props }: React.ComponentProps<typeof Icon>) => (
  <Icon component={() => <OrderDispatchedSvg className={className} />} {...props} />
);
